import React from 'react';
import './MaterialInput.scss';
import PropTypes from 'prop-types';
// import TextField, { Input } from '@material/react-text-field';
// import '@material/react-text-field/index.scss';

MaterialInput.propTypes = {
    // outlined: PropTypes.bool,
    label: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    required: PropTypes.bool,
    icon: PropTypes.any,
    onIconClick: PropTypes.func,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    errorMsg: PropTypes.string,
    wrapperClassName: PropTypes.string
};

function MaterialInput({
    label,
    value,
    onChange,
    type,
    error,
    required,
    icon,
    onIconClick,
    disabled,
    name,
    errorMsg,
    wrapperClassName
}) {
    const getClass = () => {
        if (disabled) {
            return 'material__field material__field--disabled';
        }

        if (error) {
            return 'material__field material__field--error';
        }

        return 'material__field';
    };

    return (
        <div className={`materialStyled ${wrapperClassName || ''}`}>
            <div className='material__group'>
                <input
                    name={name}
                    disabled={disabled}
                    required={required}
                    type={type}
                    className={getClass()}
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    placeholder={label} />
                <label
                    className={!error ? 'material__label' : 'material__label material__label--error'}>{label}</label>
                {icon &&
                    <img
                        src={icon}
                        alt='icon'
                        className='material__icon'
                        onClick={onIconClick} />
                }

            </div>
            {error && <div className='materialStyled__errMsg'>{errorMsg}</div>}
        </div>
    );
}

export default MaterialInput;
